import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import { useMutedCallback } from '@provider-portal/common/hooks/useMutedCallback';

export interface ModalDialogTitleProps {
  cardTitle: string;
  onClickClose: () => void;
}

export function ModalDialogTitle({ cardTitle, onClickClose }: ModalDialogTitleProps) {
  const onClickCloseHandler = useMutedCallback(onClickClose);

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography variant="h5" color="textPrimary">
          {cardTitle}
        </Typography>
      </Box>
      <Box>
        <IconButton onClick={onClickCloseHandler} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
